import styled from 'styled-components'
import PropTypes from 'prop-types'

const FixedAlignmentBox = styled.div`
  width: ${props => props.width};
  display: flex;
  justify-content: ${props => (props.justify || 'flex-start')};
  margin-right: ${props => (props.marginRight || 'none')};
`

FixedAlignmentBox.propTypes = {
  width: PropTypes.string.isRequired,
  justify: PropTypes.string,
  marginRight: PropTypes.string
}

export default FixedAlignmentBox



// WEBPACK FOOTER //
// ./src/components/mini/Layout/FixedAlignmentBox.js